// Feb 2026, user's explicit ask ("change date format everywhere in the
// app to DD-MM-YYYY (UNIVERSAL) - each and every date") - single shared
// source of truth for every date/date-time display in the app. Before
// this, each page had its own ad-hoc formatter: some used month-name
// text ("15 Oct 2026"), some used the browser's bare default locale
// (toLocaleString() with no args - renders differently depending on the
// visitor's OS/browser locale, e.g. M/D/YYYY in US English), and a couple
// already did DD/MM/YYYY but with a "/" separator instead of "-". Every
// page should import from here instead of writing its own Date
// formatting again.
const pad2 = (n) => String(n).padStart(2, "0");

function toDate(value) {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

// "15-10-2026"
export function formatDate(value, fallback = "—") {
  const d = toDate(value);
  if (!d) return fallback;
  return `${pad2(d.getDate())}-${pad2(d.getMonth() + 1)}-${d.getFullYear()}`;
}

// "15-10-2026, 07:31 pm"
export function formatDateTime(value, { seconds = false, fallback = "—" } = {}) {
  const d = toDate(value);
  if (!d) return fallback;
  const timePart = d.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    ...(seconds ? { second: "2-digit" } : {}),
    hour12: true,
  });
  return `${formatDate(d)}, ${timePart}`;
}

// "10-2026" - for month/period-only displays (e.g. Purchasing Plan's
// monthly period picker) that have no day component of their own.
export function formatMonthYear(value, fallback = "—") {
  const d = toDate(value);
  if (!d) return fallback;
  return `${pad2(d.getMonth() + 1)}-${d.getFullYear()}`;
}
